<template>
  <table class="point-list">
	<tbody>
		<tr>
			<th>日付</th>
			<td class="text-right">{{date}}</td>
		</tr>
		<tr>
			<th>注文番号</th>
			<td class="text-right">{{orderNo}}</td>
		</tr>
		<tr>
			<th>付与ポイント</th>
			<td class="text-right">{{getPoint}}</td>
		</tr>
		<tr>
			<th>使用ポイント</th>
			<td class="text-right">{{usePoint}}</td>
		</tr>
		<tr>
			<th>有効期限</th>
			<td class="text-right">{{expiry}}</td>
		</tr>
		<tr>
			<th>残ポイント</th>
			<td class="text-right">{{point}}</td>
		</tr>
		<tr>
		</tr>	
	</tbody>
  </table>
</template>
<script>
export default {
  props: ["History"],
  data(){
	return{
		date:'',
		orderNo:'',
		getPoint:'',
		usePoint:'',
		point:'',
		expiry:''
	}
  },
  mounted() {
	this.date = this.History['日付']
	this.orderNo = this.History['注文番号']
	this.getPoint = this.History['付与ポイント']
	this.usePoint = this.History['使用ポイント']
	this.point = this.History['残ポイント']
	this.expiry = this.History['有効期限年月日']
	console.log('HIstory')
	console.log(this.History)
  },
}
</script>
<style scoped>
.sp_point_container table {
    width: 100%;
}
.sp_point_container table tr {
    border-bottom: 1px solid #dee2e6;
}
.sp_point_container table th {
	font-weight: 300;
    text-align: left;
}
.sp_point_container table td {
    text-align: right;
}
</style>